module.exports = __webpack_public_path__ + "static/media/Joel_Walker_CV.82744f55.pdf";